import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { Typography, Button, LinearProgress, Fade } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { LoaderPageContainer } from '@livable/saas-react-components';
import sentMessage from 'src/img/sent-message-big.svg';
import useStyles from './styles';
export default function ProfileLoaderPage() {
  const classes = useStyles();
  const _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  setTimeout(() => setIsLoading(false), 5000);
  return /*#__PURE__*/React.createElement(LoaderPageContainer, null, isLoading && /*#__PURE__*/React.createElement("div", {
    className: classes.loaderWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h1",
    marginBottom: "18px"
  }, "Creating profile"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    marginBottom: "48px",
    className: classes.additionalInfo
  }, "Please wait a few seconds while we save your details."), /*#__PURE__*/React.createElement(LinearProgress, null)), !isLoading && /*#__PURE__*/React.createElement(Fade, {
    in: !isLoading
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.successBlockWrapper
  }, /*#__PURE__*/React.createElement("img", {
    src: sentMessage,
    width: "248",
    height: "200",
    alt: "icon message sent"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h1",
    marginBottom: "18px",
    marginTop: "32px"
  }, "Profile saved"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    marginBottom: "30px",
    className: classes.additionalInfo
  }, "We have sent a confirmation email to you.", /*#__PURE__*/React.createElement("br", null), "Please check your inbox and follow the instruction to proceed."), /*#__PURE__*/React.createElement(Button, {
    variant: "priority",
    component: RouterLink,
    to: "/mfa",
    'custom-attribute': '724-profile-loader-page'
  }, "Re-send email"))));
}